import { CreditCardType } from '../../../payment/domain/models';

const microformCardNameMap: Record<string, CreditCardType> = {
	visa: CreditCardType.Visa,
	mastercard: CreditCardType.Mastercard,
	amex: CreditCardType.AmericanExpress,
	discover: CreditCardType.Discover,
};

export function adaptMicroformCardNameToCreditCardType(
	name: string,
): CreditCardType | undefined {
	return microformCardNameMap[name.toLowerCase()];
}
